import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickCreateAppComponent } from '../quick-create-app/quick-create-app.component';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { untilDestroyed } from '@ngneat/until-destroy';
import { QuickCreateAppBubbleButtonService } from './quick-create-app-bubble-button.service';
import { catchError, tap, throwError } from 'rxjs';
import { UtilComponent } from 'app/shared/common/utils/UtilComponent';

@Component({
  selector: 'app-quick-create-app-bubble-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslocoModule
  ],
  templateUrl: './quick-create-app-bubble-button.component.html',
  styleUrls: ['./quick-create-app-bubble-button.component.scss']
})
export class QuickCreateAppBubbleButtonComponent implements OnInit {

  constructor(private _dialog: MatDialog, private _initAppService: QuickCreateAppBubbleButtonService, private _utilComponent: UtilComponent, private _translocoService: TranslocoService) { }

  ngOnInit(): void {
  }

  public initNewApp() {
    const dialogRef = this._dialog?.open(QuickCreateAppComponent, {
      autoFocus: false,
      hasBackdrop: true,
      maxWidth: '600px',
      width: '600px'
    })
    dialogRef['componentInstance'].submitClicked.pipe(untilDestroyed(dialogRef?.componentInstance))?.subscribe((payload) => {
      this._initAppService.quickInitApp(payload).pipe(
        tap(() => {
          this._utilComponent.openSnackBar(this._translocoService.translate('ACTION_SUCCESS'), 'complete');
          dialogRef?.close();
        })
      ).subscribe();
    })
  }

}
